import Nav from "./nav.jsx";

export default Nav;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/navigation/index.js